import { trpc } from '@tencent/tpro_rmonitor_web_server_exception';
import moment from 'moment';
import { getUserId } from '@/infrastructure/auth';
import { getAxios, TRPCGet, TRPCPost } from '@/infrastructure/axios';
import { API_PREFIX, BusiCode } from '@/infrastructure/axios/code';
import { logger } from '@/infrastructure/logger';
import { getPid, getProductId } from '@/infrastructure/product-info';
import { TapdInfoType } from '@/presentation/components/tapd-info/edit-tapd-modal';
import { CustomFieldsType, StatusRulesType } from '@/presentation/components/tapd/create-tapd-modal';
import {
  IBindTAPDIssueReq,
  IBindTAPDIssueResp,
} from '@/proto/excep-data-portal';
import { Zone } from '@/proto/field';
import { IssueType } from '@/proto/issue';
import {
  IAddTapdInfoReq,
  IAddTapdInfoResp,
  ICreateTapdIssueReq,
  ICreateTapdIssueRsp,
  IDeleteIssueTapdTemplateInfoReq,
  IDeleteIssueTapdTemplateInfoRsp,
  IDeleteTapdInfoReq,
  IDeleteTapdInfoResp,
  IGetCustomFieldsReq,
  IGetCustomFieldsResp,
  IGetIssueTapdTemplateInfosReq,
  IGetIssueTapdTemplateInfosRsp,
  IGetTapdInfoReq,
  IGetTapdInfoResp, IReleaseTapdIssueReq, IReleaseTapdIssueRsp,
  ISaveIssueTapdTemplateInfosReq,
  ISaveIssueTapdTemplateInfosRsp,
  ITapdTemplateInfos,
} from '@/proto/manage';
import { exceptionService } from '@/service/exception';
import { WithTypeCast } from '@raft/utils';
type ClusterStackType = WithTypeCast<trpc.rmonitor.web_server.ClusterStackType>;

export interface BaseRsp {
  status: 'ok' | 'error';
  baseRsp: {
    code: number;
    msg: string;
  };
  base_rsp: {
    code: number;
    msg: string;
  };
}


export interface TapdInfo {
  id: string;
  product_id: string;
  access_token: string;
  token_type: string;
  workspace_id: string;
  workspace_name: string;
  creator: string;
}


export interface TapdInfoRsp extends BaseRsp {
  tapd_infos: TapdInfo[];
}

export interface AddTapdInfoReq {
  code: string;
  redirect_uri: string;
  product_id: string;
  creator: string;
}

export interface CreateTapdIssueReq {
  product_id: string;
  type: Zone;
  issue_key: string;
  work_space_id: string;
  field_values: Record<string, any>[];
  remark?: string;
}

export interface BindTapdIssueReq {
  appID: string;
  type: Zone;
  issueUUID: string;
  tapdID: string;
  workSpaceID: string;
}

export interface ReleaseTapdIssueReq {
  appID: string;
  type: Zone;
  issueUUID: string;
}

export interface GetIssueTapdTemplateInfoReq {
  product_id: string;
  work_space_id: string;
}

export interface SaveIssueTapdTemplateInfoReq {
  product_id: string;
  work_space_id: string;
  operator: string;
  data: Record<string, any>[];
  status_rules: Record<string, any>[];
  name: string;
  issue_tapd_template_id?: string;
}

export interface TapdTemplateInfos {
  creator: string;
  template_id: string;
  template_name: string;
  data: TapdInfoType[];
  status_rules: StatusRulesType[];
}

interface Tapd {
  workSpaceID: string;
  title?: string;
  processors?: string[];
  comment?: string;
  desc?: string;
  fields: Record<string, any>[];
}

interface Issue {
  UUID: string;
  status: number;
  note?: string;
}

export interface SubmitToTapdReq {
  issueTapds: {
    issue: Issue;
    tapd: Tapd;
  }[];
}

/** 获取tapd列表 */
export const getTapdList = async (productId: string): Promise<IGetTapdInfoResp | undefined> => {
  const params: IGetTapdInfoReq = {
    productId,
  };
  try {
    return await TRPCGet<TapdInfoRsp>(`/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.Tapd/GetTapdInfo`, { params });
  } catch (e) {
    return undefined;
  }
};

/** 关联tapd信息 */
export const setTapdInfo = async (params: IAddTapdInfoReq): Promise<IAddTapdInfoResp | undefined> => {
  try {
    return await TRPCPost<IAddTapdInfoResp>(`/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.Tapd/AddTapdInfo`, params);
  } catch (e) {
    return undefined;
  }
};

/** 删除tapd信息 */
export const deleteTapdInfo = async (ids: number[]): Promise<IDeleteTapdInfoResp | undefined> => {
  const params: IDeleteTapdInfoReq = {
    ids,
  };
  try {
    return await TRPCPost<IDeleteTapdInfoResp>(`/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.Tapd/DeleteTapdInfo`, params);
  } catch (e) {
    return undefined;
  }
};

/** 创建tapd派单 */
export const createTapdIssue = async (params: ICreateTapdIssueReq): Promise<ICreateTapdIssueRsp | undefined> => {
  try {
    return await TRPCPost<ICreateTapdIssueRsp>(`/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.IssueTrack/CreateTapdIssue`, params);
  } catch (e) {
    return undefined;
  }
};

/** 绑定已有tapd单 **/
export const bindTapdIssue = async (params: IBindTAPDIssueReq): Promise<IBindTAPDIssueResp | undefined> => {
  try {
    return await TRPCPost<IBindTAPDIssueResp>(`/${API_PREFIX}/trpc/trpc.eff_tool.excep_data_portal.ExcepDataPortal/BindTAPDIssue`, params);
  } catch (e) {
    logger.error('bindTapdIssue:', e);
    return undefined;
  }
};

/** 解除已关联tapd单 **/
export const releaseTapdIssue = async (params: IReleaseTapdIssueReq): Promise<IReleaseTapdIssueRsp | undefined> => {
  try {
    return await TRPCPost<IReleaseTapdIssueRsp>(`/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.IssueTrack/ReleaseTapdIssue`, params);
  } catch (e) {
    return undefined;
  }
};

/** 获取tapd模版基本信息 woa**/
export const getIssueTapdInfos = async (params: IGetIssueTapdTemplateInfosReq): Promise<ITapdTemplateInfos[]> => {
  const emptyList = [
    {
      creator: '',
      templateId: '',
      templateName: '',
      data: [],
      statusRules: [],
    },
  ];
  try {
    const res = await TRPCPost<IGetIssueTapdTemplateInfosRsp>(`/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.IssueTapdTemplate/GetIssueTapdTemplateInfos`, params);
    return res.infos || emptyList;
  } catch (e) {
    return emptyList;
  }
};

/** 删除tapd模板基本信息 woa **/
export const deleteIssueTapdInfos = async (params: IDeleteIssueTapdTemplateInfoReq):
Promise<boolean> => {
  try {
    const res = await TRPCPost<IDeleteIssueTapdTemplateInfoRsp>(`/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.IssueTapdTemplate/DeleteIssueTapdTemplateInfo`, params);
    return res?.baseRsp?.code === BusiCode.Ok;
  } catch (e) {
    return false;
  }
};

/** 保存tapd模板基本信息 woa**/
export const saveIssueTapdInfos = async (params: ISaveIssueTapdTemplateInfosReq):
Promise<number | null | undefined> => {
  try {
    const res = await TRPCPost<ISaveIssueTapdTemplateInfosRsp>(`/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.IssueTapdTemplate/SaveIssueTapdTemplateInfos`, params);
    return res?.templateId;
  } catch (e) {
    return undefined;
  }
};

/** 获取某个bug单的自定义字段 **/
export const getCustomFields = async (workspaceId: string): Promise<CustomFieldsType[]> => {
  const params: IGetCustomFieldsReq = {
    workspaceId,
  };
  try {
    const res = await TRPCPost<IGetCustomFieldsResp>(`/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.Tapd/GetCustomFields`, params);
    return res.customFields?.map((item: any) => ({
      name: item.name,
      label: item.label,
      options: item.options,
      type: !!item.options.length ? 'select' : 'input',
    })) || [];
  } catch (e) {
    return [];
  }
};

/** 获取tapd转单详情内容 **/
export const getLastCrashStack = async (crashId: string) => {
  try {
    const res = await getAxios().get(`/${API_PREFIX}/api/crash/last-stack?appId=${getProductId()}&pid=${getPid()}&crashId=${crashId}`);
    return {
      detail: res.data.retraceCrashDetail as string,
      exceptionName: res.data.exceptionName as string,
      exceptionMessage: res.data.exceptionMessage as string,
      crashId,
    };
  } catch (e) {
    logger.error('getLastCrashStack', e);
    return {
      detail: '',
      crashId: '',
      exceptionName: '',
      exceptionMessage: '',
    };
  }
};

export const getLastCrashStackNew = async (
  crashId: string,
  issueType: IssueType,
  feature: string,
  clusterStackType?: ClusterStackType,
) => {
  try {
    const crashDetail = await exceptionService.getDetail({
      productId: getProductId(),
      issueType,
      clientIdentify: crashId,
      feature,
      clusterStackType,
    });

    return {
      detail: crashDetail?.translatedStack ?? '',
      exceptionName: crashDetail?.expName ?? '',
      exceptionMessage: crashDetail?.exceptionMsg ?? '',
      crashId,
    };
  } catch (e) {
    logger.error('getLastCrashStack', e);
    return {
      detail: '',
      crashId: '',
      exceptionName: '',
      exceptionMessage: '',
    };
  }
};

/** 提交tapd缺陷单 **/
export const submitToTapd = async (params: SubmitToTapdReq) => {
  try {
    return await getAxios().post(`/${API_PREFIX}/api/issue/tapd/add`, {
      ...params,
      appId: getProductId(),
      pid: getPid(),
      userId: getUserId(),
      createTime: moment().format('YYYY-MM-DD HH:mm:ss'),
    });
  } catch (e) {
    logger.error('submitToTapd:', e);
    return false;
  }
};
